import React from 'react';
import { CacheAdmin } from '../components';
import { useTranslation } from '../context/TranslationContext';

/**
 * Page d'administration du cache mémoire local
 * Permet de surveiller et gérer le cache des données de configuration
 */
const CacheAdminPage = () => {
  const { t } = useTranslation();

  return (
    <div className="container mx-auto px-4 py-8">
      <CacheAdmin />
    </div>
  );
};

export default CacheAdminPage;
